// ClientDashboard.js - Version: v1 i5

import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackButton from "./BackButton"; // Standard-Zurück-Button einfügen
import "./ClientDashboard.css"; // Styles importieren

export default function ClientDashboard() {
    const navigate = useNavigate();
    const logo = "/logo192.png"; // Logo aus /public/-Ordner laden
    const location = useLocation();

    useEffect(() => {
        const role = localStorage.getItem("role");
        const token = localStorage.getItem("token");

        if (role !== "client" || !token) {
            console.log("❌ Ungültige Rolle oder kein Token, Weiterleitung zum Login");
            navigate("/login");
            return;
        }

        console.log("📌 ClientDashboard geladen, Token gefunden:", token);
    }, [navigate]);

    return (
        <div className="client-dashboard-container">
            <div className="client-dashboard-box">
                <img src={logo} alt="FreiSeinApp Logo" className="client-dashboard-logo" />
                <h2>🏆 Client Dashboard</h2>
                <p className="client-content">Willkommen in deinem persönlichen Bereich.</p>

                {/* Button für den Coaching-Bereich */}
                <div className="client-actions">
                    <button className="coaching-button" onClick={() => navigate("/client-coaching")}>
                        📖 Zum Coaching-Bereich
                    </button>
                </div>

                {/* 🔙 Standard-Zurück-Button */}
                {location.pathname !== "/client-coaching" && <BackButton />}
            </div>
        </div>
    );
}